import React from 'react';
import {Modal} from 'antd';
import {MODALS} from 'utils/constants';
import {useDispatch, useSelector} from 'react-redux';
import {setActiveModal} from '../../store/global/actions';
import './PasswordReminderModal.scss';

export const PasswordReminderModal = () => {
    const dispatch = useDispatch();
    const {activeModal} = useSelector(({global}) => global);
    const onAccept = async () => {
        dispatch(setActiveModal(MODALS.CHANGE_PASSWORD));
    };

    const onDecline = async () => {
        dispatch(setActiveModal(null));
    };

    return (
        <Modal
            centered={window.innerWidth > 1024 ? true : false}
            title={
                <div>
                    <div style={{color: '#A3A2A2'}}>
                        DBS Research - Password Change Reminder
                    </div>
                </div>
            }
            visible={activeModal === MODALS.PASSWORD_REMAINDER}
            closable={false}
            onCancel={() => onDecline()}
            destroyOnClose
            cancelText="Skip"
            okText="Change Password"
            onOk={() => onAccept()}
            wrapClassName="terms-modal"
            maskStyle={{
                backdropFilter: 'blur(6px)',
                background: '#fff0',
            }}
            className="disclaimer-modal"
            data-testid="disclaimer-modal-1"
            maskClosable={false}
        >
            <div className="password-reminder">
                <h4>Consider changing your password</h4>

                <p>
                    Your password expires on 23rd October 2023. To change your
                    password now, please click on "Change Password" below.
                </p>
                <p>
                    The new password should comply with the following
                    guidelines:
                </p>
                <ol className="password-reminder--list">
                    <li>Password must be at least 8 characters in length.</li>
                    <li>
                        Password must include at least 1 uppercase character and
                        1 number.
                    </li>
                    <li>
                        Password must include at least one of the following
                        special characters {'!@#$%^&*()_+<>?'}
                    </li>
                    <li>Password cannot be the same as email.</li>
                    <li>
                        Password cannot have 3 or more consecutive same
                        characters.
                    </li>
                </ol>
            </div>
        </Modal>
    );
};
